import { Directive, HostBinding, HostListener } from '@angular/core';
import * as $ from 'jquery';

@Directive({
    selector: '[appExpandMenu]'
})

export class AppExpandMenu {

    @HostBinding('class.active') isOpen = false;

    @HostListener('click', ['$event.target']) toggleOpen($event) {
        this.isOpen = !this.isOpen;

        $( document ).ready(() => {
            const id = $($event).attr('id');
            if (this.isOpen) {
                $('.' + id).slideDown();
            } else {
                $('.' + id).slideUp();
            }
        });
    }
}
